import { render, staticRenderFns } from "./AboutContent.vue?vue&type=template&id=22c28203&"
import script from "./AboutContent.vue?vue&type=script&lang=js&"
export * from "./AboutContent.vue?vue&type=script&lang=js&"
import style0 from "./AboutContent.vue?vue&type=style&index=0&id=22c28203&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports